import { useEffect, useState } from 'react'
import { api } from '../../utils'

const ENDPOINT = 'llm-visibility-schedules/answer-service-options/'

export const answerServicesFromRecord = (record, current) => ({
  ...current,
  ...record.answer_services,
})

export const selectedAnswerServices = (selected, services) =>
  Object.keys(selected).reduce((result, llm) => {
    if (selected[llm]) result[llm] = services[llm]
    return result
  }, {})

export const useAnswerServiceOptions = (setAnswerServices) => {
  const [options, setOptions] = useState(null)
  const [error, setError] = useState(false)

  useEffect(() => {
    let mounted = true
    api
      .get(ENDPOINT)
      .then(({ data }) => {
        if (!mounted) return
        const defaults = Object.fromEntries(
          data.providers.map(({ id, default: mode }) => [id, mode])
        )
        setAnswerServices((current) => ({ ...defaults, ...current }))
        setOptions(data)
      })
      .catch(() => {
        if (mounted) setError(true)
      })
    return () => {
      mounted = false
    }
  }, [setAnswerServices])

  return { options, error }
}

export const hasSelectedAnswerServices = (selected, services, options) =>
  !!options &&
  Object.keys(selected)
    .filter((id) => selected[id])
    .every((id) =>
      options.providers.some(
        ({ id: providerId, modes }) =>
          providerId === id && modes.some(({ id: modeId }) => modeId === services[id])
      )
    )
